<script setup>
defineProps({
  feedbackItem: {
    type: Object,
    required: true,
  }
})

const emit = defineEmits(['close'])
</script>

<template>
  <button
    type="button"
    class="tw-bg-info tw-h-7 tw-w-7 tw-text-white tw-rounded-xl tw-p-1 tw-inline-flex tw-justify-center tw-items-center tw-align-baseline tw-mx-1"
    @click="emit('click', feedbackItem)"
  >
    <svg-vue
      class="tw-h-3"
      icon="icons/chat-message"
    />
  </button>
</template>
